import { request } from '@app/http/request'
import { appConfig } from '@app/shared/config'
import type { SpResponse } from '@backend-models/common/request/sp-response'
import type { GetFeatureFlagsResponse } from '@backend-models/feature-flags/get/get-feature-flags-response'

export const getFeatureFlags = async (hideLoading = true): Promise<SpResponse<GetFeatureFlagsResponse | null>> => {
  try {
    const req = await request(`${appConfig.api}/feature-flags`, { hideLoading, auth: true })
    const res = await req.json()
    return res
  } catch (error) {
    console.error(error)
    return { data: null, success: false }
  }
}
